import React from 'react';
import { Card, Stack } from '@fiverr-private/layout_components';
import { I18n } from '@fiverr-private/i18n-react';
import { Typography } from '@fiverr-private/typography';
import { InfoCircleIcon } from '@fiverr-private/visuals';
import { Tooltip } from '@fiverr-private/tooltip';
import { Button } from '@fiverr-private/button';
import { Box } from '@fiverr-private/theme';
import { useResizableRef } from '@fiverr-private/legal_documents_package';
import { ComplianceType } from '../../ComplianceModal/types';

export const ComplianceCallToAction = ({
    complianceType,
    onClick,
    hideDetails,
}: {
    complianceType: ComplianceType;
    onClick: () => void;
    hideDetails?: boolean;
}) => {
    const { ref, compact } = useResizableRef();
    return (
        <Card padding={'0'} borderRadius="lg" ref={ref}>
            <Stack
                paddingLeft={compact ? '4' : '5'}
                paddingRight={compact ? '2' : '3'}
                paddingY={compact ? '1.5' : '2'}
                alignItems={'center'}
                width={'100%'}
            >
                <Box textOverflow={'ellipsis'} overflow={'hidden'} whiteSpace="nowrap">
                    <Typography
                        size={
                            compact
                                ? 'b_sm'
                                : {
                                      default: 'b_sm',
                                      sm: 'b_md',
                                  }
                        }
                        color="grey_1200"
                        textOverflow={'ellipsis'}
                        overflow={'hidden'}
                        whiteSpace="nowrap"
                    >
                        <I18n k={`compliance.first_time_compliance_section.types.${complianceType}`} />
                    </Typography>
                </Box>

                {!hideDetails && (
                    <>
                        <Box
                            flexShrink={1}
                            display={
                                compact
                                    ? 'none'
                                    : {
                                          default: 'none',
                                          sm: 'block',
                                      }
                            }
                            textOverflow={'ellipsis'}
                            overflow={'hidden'}
                            whiteSpace="nowrap"
                        >
                            <Typography
                                flexShrink={1}
                                color="grey_900"
                                size={
                                    compact
                                        ? 'b_sm'
                                        : {
                                              default: 'b_sm',
                                              sm: 'b_md',
                                          }
                                }
                                textOverflow={'ellipsis'}
                                overflow={'hidden'}
                                whiteSpace="nowrap"
                            >
                                <I18n k={`compliance.compliance_section.${complianceType}.details`} />
                            </Typography>
                        </Box>
                        <Tooltip
                            position="bottom"
                            content={<I18n k={`compliance.compliance_section.${complianceType}.details`} />}
                        >
                            <Box
                                // here
                                display={
                                    compact
                                        ? 'flex'
                                        : {
                                              default: 'flex',
                                              sm: 'none',
                                          }
                                }
                                marginBottom={'0.5'}
                                alignItems={'center'}
                            >
                                <InfoCircleIcon size="sm" color="grey_800" />
                            </Box>
                        </Tooltip>
                    </>
                )}
                <Stack flexShrink={0} marginLeft={'auto'}>
                    <Button onClick={onClick} variant="ghost" size={'sm'} style={{ height: '32px' }}>
                        <Typography size="b_sm">
                            <I18n k={`compliance.compliance_section.${complianceType}.cta`} />
                        </Typography>
                    </Button>
                </Stack>
            </Stack>
        </Card>
    );
};
